export default "__VITE_ASSET__DggnLWtx__"